export { default as Header } from './header'
export { default as Features } from './features'
export { default as FindLobby } from './findLobby'
export { default as MoreInfo } from './moreInfo'
export { default as OpenSource } from './openSource'
export { default as Community } from './community'
export { default as Tetris } from './tetris'
